import { SelectionChangeEventDetails, SelectOption } from "@/types/types";
import { CustomEventType } from "@/events/CustomEventRegistry";
import { css, CSSResultGroup, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("basic-select")
export class BasicSelect extends LitElement {
	static readonly styles: CSSResultGroup = css`
    select {
      width: 100%;
      font-family: var(--font-headline);
      font-size: 1rem;
      color: black;
      background: white;
      border: var(--border-default);
      padding: 10px 20px;
      border-radius: var(--border-radius);
      cursor: pointer;
      box-shadow: var(--shadow-default);
      transition: all 0.3s ease;
      white-space: pre-wrap;
      text-overflow: ellipsis;
    }
    
    select option.placeholder {
      color: #999;
      font-style: italic;
    }
  `;

	@property() value: string = "";
	@property({ type: Array }) options: SelectOption[] = [];
	@property({ type: String }) rowIndex: string = "";
	@property({ type: String }) placeholder: string = "Auswählen...";
	@property({ type: String }) additionalCustomEventIdentifier: string = "";

	private get isValidValue(): boolean {
		return this.options.some(option => option.value === this.value);
	}

	private get controlledValue(): string {
		return this.isValidValue ? this.value : "";
	}

	private _handleSelectionChange = (event: Event) => {
		const selectElement = event.target as HTMLSelectElement;
		const newValue = selectElement.value;
		const newOption = this.options.find(option => option.value === newValue);
		const previousOption = this.options.find(option => option.value === this.controlledValue);

		this.dispatchEvent(new CustomEvent<SelectionChangeEventDetails>(CustomEventType.SELECTION_CHANGE, {
			detail: {
				rowIndex: this.rowIndex,
				previousValue: this.controlledValue,
				previousLabel: previousOption?.label || "",
				newValue: newValue,
				newLabel: newOption?.label || "",
				additionalCustomEventIdentifier: this.additionalCustomEventIdentifier
			},
			bubbles: true,
			composed: true
		}));
	};

	render() {
		return html`
			<select @change="${this._handleSelectionChange}">
				${!this.isValidValue ? html`
				<option value="" class="placeholder" selected>
					${this.placeholder}
				</option>
				` : ''}
				
				${this.options.map((option) => html`
				<option value="${option.value}" ?selected=${this.controlledValue === option.value}>
					${option.label}
				</option>
				`)}
			</select>
    	`;
	}
}

export default BasicSelect;